var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisputes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1546_119832)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.1216 32.3347L39.1219 32.3352C40.1762 34.0585 38.8835 36.2992 36.6663 36.2992H3.33855C1.10949 36.2992 -0.172688 34.0533 0.876316 32.3347L0.87634 32.3347L17.5365 5.03516C17.5365 5.03505 17.5366 5.03494 17.5367 5.03484C18.6271 3.25304 21.3784 3.25522 22.4608 5.03413L22.4612 5.03468L39.1216 32.3347ZM20.6284 26.8492H19.3626L18.8503 14.1992H21.1407L20.6284 26.8492ZM1.93953 32.8637L1.93816 32.8659C1.28866 33.9425 2.13726 35.1992 3.3316 35.1992H36.6663C37.8587 35.1992 38.7131 33.9351 38.0508 32.8626C38.0505 32.8621 38.0502 32.8616 38.0498 32.8611L21.3855 5.56593C21.3853 5.56559 21.385 5.56525 21.3848 5.5649C20.764 4.53756 19.2225 4.55287 18.6066 5.56415L1.93953 32.8637ZM18.5544 30.4992C18.5544 29.7845 19.1716 29.1617 19.999 29.1617C20.8263 29.1617 21.4435 29.7845 21.4435 30.4992C21.4435 31.214 20.8263 31.8367 19.999 31.8367C19.1716 31.8367 18.5544 31.214 18.5544 30.4992Z",
    stroke: "#61A578"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1546_119832"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisputes);
export default __webpack_public_path__ + "static/media/disputes.6ab2740497965112c9c2fbabb327ee8f.svg";
export { ForwardRef as ReactComponent };